import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

type EventGalleryPhotoProps = {
    tools: Array<React.JSX.Element>;
};

/**
 * EventGalleryPhotoTools component - displays tool buttons in a positioned overlay
 * Now uses theme-aware styling instead of CSS classes for better maintainability
 * and automatic dark/light theme support.
 */
const EventGalleryPhotoTools: FC<EventGalleryPhotoProps> = ({ tools }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.primaryLight.main,
                position: 'absolute',
                right: 0, // Position from right edge
                bottom: 0, // Position from bottom edge
                display: 'flex',
                flexDirection: 'column', // Stack tools vertically
                zIndex: 100,
                borderTopLeftRadius: theme.shape.borderRadius,
                // Smooth transitions for theme changes
                transition: theme.transitions.create(['background-color'], {
                    duration: theme.transitions.duration.short,
                }),
            }}
        >
            {tools}
        </Box>
    );
};

export { EventGalleryPhotoTools };
